import { OpenTaskListData } from 'dy-frontend-shared/lib/data/types';
import domain from './domain';
import { resetTeamOpenTaskListData } from './events';

// Open task list data
export const $teamOpenTaskListData = domain
    .createStore<OpenTaskListData | null>(null)
    .reset(resetTeamOpenTaskListData);
